export const aboutPospQuestions = [
  {
    question: 'What exactly is a POSP Insurance Agent?',
    answer:
      'A Point of Sales Person or POS is a self employed sales superstar responsible for selling various financial products without breaking a sweat. They act as a bridge between the customer and the companies they represent offering the best solution that caters to the client needs.',
  },
  {
    question: 'What is the eligibility criteria to become a POSP Insurance Agent?',
    answer:
      'Given below is the eligibility criteria to become a POSP Insurance Agent: You need to be minimum 18 years of age You should have passed class 10',
  },
  {
    question: 'What are documents required to become a POSP Insurance Agent?',
    answer: '  To become a POSP Insurance Agent, you must submit the below documents: PAN Card Aadhar Card Photograph Highest Educational Qualification Proof',
  },
  {
    question: 'Is it mandatory to appear for POSP Training?',
    answer:
      ' Yes, it is mandatory to complete the basic 15-hour POSP training as directed by the IRDAI. After the training, you are required to appear for the examination to become a certified POSP.',
  },
  {
    question: 'What type of insurance products POSP can sell?',
    answer:
      'As a POSP, you can sell various types of insurance products such as health insurance, travel insurance, motor insurance, life insurance etc',
  },
];
